import { Vue } from 'vue-property-decorator'
import { ServiceRequestRepository } from './ServiceRequestHistoryUnitRepository'
import ServiceRequestModel from '../../../ServiceRequestModel'
import { JtechStore } from 'src/plugins/mobx'

export default class ServiceRequestHistoryUnitController {
  state = ServiceRequestModel.getInstance();

  static getInstance () {
    return JtechStore.getSingleton('ServiceRequestHistoryUnitController', new ServiceRequestHistoryUnitController())
  }

  async load (params) {
    return await ServiceRequestRepository.load(params)
  }

  async loadHistoryDataByConsumerUnit (consumerUnit) {
    return await ServiceRequestRepository.loadHistoryDataByConsumerUnit(consumerUnit)
  }

  async loadHistoryForm () {
    return await ServiceRequestRepository.loadHistoryForm()
  }
}
